import React from "react";

import { StyledWrapper, StyledDivider } from "./challengeLeaderboard.style";
import SingleTier from "./singleTier/singleTier.component";

const ChallengeLeaderboard = ({ data }) => {
  return (
    <StyledWrapper>
      <StyledDivider />
      <h1>Leaderboard</h1>
      <div>
        {data.map((tier, index) => (
          <SingleTier key={index} data={tier} />
        ))}
      </div>
    </StyledWrapper>
  );
};

export default ChallengeLeaderboard;
